import MailSupport from '../misc/MailSupport'
import React from 'react'

export default function TermsAndConditions() {
  return (
    <div className="policy-container">
      <h1>Terms and Conditions</h1>
      <p>Last updated: April 5, 2026</p>
      <p>Please read these terms and conditions carefully before using the Service.</p>

      <h2>Interpretation and Definitions</h2>
      <h3>Definitions</h3>
      <p>For the purposes of these Terms and Conditions:</p>
      <ul>
        <li>
          <p><strong>Account</strong> means a unique account created for You to access our Service or parts of our Service.</p>
        </li>
        <li>
          <p><strong>Company</strong> (referred to as either &quot;the Company&quot;, &quot;We&quot;, &quot;Us&quot; or &quot;Our&quot; in this Agreement) refers to Dichroic Software, LLC, Dedham, MA 02026.</p>
        </li>
        <li>
          <p><strong>Content</strong> means information You submit through the Service, including bracket names, pool names, bracket picks, and other text or data You provide.</p>
        </li>
        <li>
          <p><strong>Service</strong> refers to the Website.</p>
        </li>
        <li>
          <p><strong>Website</strong> refers to World Cup Bracket Challenge, accessible from <a href="https://bracketchallenge.world" rel="external nofollow noopener" target="_blank">https://bracketchallenge.world</a>.</p>
        </li>
        <li>
          <p><strong>You</strong> means the individual accessing or using the Service, or the company or other legal entity on behalf of which such individual is accessing or using the Service, as applicable.</p>
        </li>
      </ul>

      <h2>Acknowledgment</h2>
      <p>These Terms and Conditions govern Your use of the Service. By accessing or using the Service, You agree to be bound by these Terms and Conditions. If You do not agree, do not use the Service.</p>
      <p>Your use of the Service is also subject to Our Privacy Policy. Please read it carefully before using the Service.</p>
      <p>You represent that You are at least 18 years old. The Company does not permit those under 18 to use the Service.</p>

      <h2>Accounts and Authentication</h2>
      <p>Some features of the Service require an account. You agree to provide accurate, complete, and current information when You create or use an account.</p>
      <p>Authentication for the Service may be provided through a third-party identity provider, including Auth0. We do not control the operation of that provider, and Your use of that provider is also subject to its terms and privacy practices.</p>
      <p>You are responsible for maintaining the security of Your account and for activity that occurs under it. If You believe Your account has been compromised, contact Us promptly.</p>

      <h2>Brackets, Pools, and Content</h2>
      <p>The Service allows You to create and submit bracket picks, join pools, and share related information with other users. You are responsible for the Content You submit and for making sure it does not violate any law or the rights of others.</p>
      <p>By submitting Content through the Service, You grant Us a non-exclusive, worldwide, royalty-free license to host, store, reproduce, and display that Content as necessary to operate, maintain, and improve the Service.</p>
      <p>You must not submit Content that is unlawful, misleading, abusive, defamatory, obscene, infringing, or otherwise objectionable. We may remove Content or restrict access to the Service if We reasonably believe these Terms have been violated.</p>

      <h2>Scoring and Tournament Rules</h2>
      <p>The Service is a bracket challenge product. Scoring is strict and is based on the published rules of the Service for the applicable tournament and bracket type.</p>
      <p>Matchups, third-place placements, and bracket paths may depend on official tournament rules and published FIFA regulations, including official third-place combination tables where applicable. We may correct configuration, seeding, or scoring errors if necessary to keep the Service aligned with those rules.</p>

      <h2>Availability and Changes</h2>
      <p>We may modify, suspend, or discontinue any part of the Service at any time, with or without notice. We do not guarantee that the Service will always be available, uninterrupted, or error-free.</p>
      <p>We may update these Terms from time to time. If We make material changes, We will post the updated Terms on this page and update the &quot;Last updated&quot; date above. Your continued use of the Service after the updated Terms take effect means You accept the revised Terms.</p>

      <h2>Intellectual Property</h2>
      <p>The Service and its original content, features, and functionality are and will remain the exclusive property of the Company and its licensors, except for Content You submit.</p>

      <h2>Termination</h2>
      <p>We may suspend or terminate Your access to the Service at any time if We believe You have violated these Terms, created risk for other users, or exposed the Company to legal or operational risk.</p>
      <p>You may stop using the Service at any time. If You want Us to delete account-related information, contact Us and We will review the request in accordance with Our Privacy Policy and applicable law.</p>

      <h2>Links to Other Websites</h2>
      <p>The Service may contain links to third-party websites or services that are not owned or controlled by the Company. We are not responsible for the content, terms, or privacy practices of those third parties.</p>

      <h2>Disclaimer</h2>
      <p>The Service is provided &quot;AS IS&quot; and &quot;AS AVAILABLE&quot; without warranties of any kind, whether express or implied, to the maximum extent permitted by law.</p>

      <h2>Limitation of Liability</h2>
      <p>To the maximum extent permitted by law, the Company and its suppliers will not be liable for any indirect, incidental, special, consequential, or punitive damages, or for any loss of profits, data, goodwill, or business opportunities arising out of or related to Your use of the Service.</p>

      <h2>Governing Law</h2>
      <p>These Terms are governed by the laws of the Commonwealth of Massachusetts, without regard to conflict of law principles.</p>

      <h2>Contact Us</h2>
      <p>If You have any questions about these Terms and Conditions, You can contact Us at <MailSupport />.</p>
    </div>
  )
}
